import React from "react"
import {CmCollection} from "../../../../packages/graphql-layer/src";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import "../../../utility/i18n"
import CCOContainer from "../../fundamentals/CCOContainer";
import DownloadItems from "./DownloadItems";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import {getContainerWidth} from "../../../utility/componentUtil";

export interface Props {
    cmCollection: CmCollection,
    layoutSettings?: any,
}

function C003Download(props: Props) {
    const containerWidth = getContainerWidth(props.layoutSettings?.contentWidth);

    return (
        <CCOComponentWrapper dataCypress={'downloadComponent'}>
            {props.cmCollection.items && props.cmCollection.items.length > 0 ?
                <CCOHeadline id={props.cmCollection.id} metadataId={props.cmCollection.id} headline={props.cmCollection.teaserTitle}
                             type={"componenthead"}
                             propertyName='properties.teaserTitle'
                             subtextPropertyName='properties.teaserText'
                             subtext={props.cmCollection.teaserText?.textAsTree}
                /> : <></>}
            <CCOContainer width={containerWidth}>
                <DownloadItems cmCollection={props.cmCollection}/>
            </CCOContainer>
        </CCOComponentWrapper>
    )
}

export default C003Download